import { ChangeDetectionStrategy, Component, output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tiime-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TiimeOverlayComponent {
  readonly closeOverlay = output<void>();

  close(): void {
    this.closeOverlay.emit();
  }
}
